import React from 'react';
import SplitPane from 'react-split-pane';
import ReactTable from "react-table";

import { Button, Modal } from 'react-bootstrap';
import { MapEventData, MapEvent } from '../ReactProtos/Proto/dcei_wildsky_map_event_proto';
import { Menu, Item, Separator } from 'react-contexify';
import { ProtoEditor } from '../ReactProtos/ProtoEditor';

import 'react-table/react-table.css';

import './custom.scss';

/* eslint react/prop-types: 0 */

/**
 * @param {MapEventData} data
 */
function applyAction(data, action) {
    if (action.type == 'BATCH') {
        for (let item of action.actions) {
            data = applyAction(data, item);
        }
        return data;
    }
    return data.apply(action.type, action.path, action.value);
}

const FormContextMenu = (props) => {
    const { onClick } = props;
    return (
        <Menu id='form-context-menu'>
            <Item onClick={(e, props) => onClick('Copy', e, props)}>Copy</Item>
            <Separator />
            <Item onClick={(e, props) => onClick('Paste', e, props)}>Paste</Item>
            <Separator />
            <Item onClick={(e, props) => onClick('Clear', e, props)}>Clear</Item>
        </Menu>
    );
};

export class MapEventEditor extends React.PureComponent {
    dispatchPath = [];
    eventListColumns = [
        {
            accessor: "name",
            Header: "Name",
            sortable: false,
        }
    ];

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            files: [],
            downloading: false,
            href: '',
            data: this.getSavedData() || MapEventData.WithParent.default,
            selected: '',
        };
    }

    STORAGE_KEY = "MapEventEditor.Data";

    getSavedData() {
        const text = window.localStorage.getItem(this.STORAGE_KEY);
        if (!text) {
            return null;
        }
        return new MapEventData.WithParent(MapEventData.fromJson(JSON.parse(text)), null);
    }

    componentDidUpdate() {
        window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.state.data.selfValue.toJson()));
    }

    getTdProps = (state, rowInfo) => {
        // console.log('td props', state, rowInfo);
        return {
            style: {
                cursor: 'pointer',
                background: this.state.selected == rowInfo.original.name ? "gold" : null,
            },
            onClick: () => {
                // console.log("It was in this row:", rowInfo, state, instance);
                this.setState({ selected: rowInfo.original.name });
            }
        };
    }

    dispatch = action => {
        const data = this.state.data;
        const newData = applyAction(data.selfValue, action);
        if (newData !== data.selfValue) {
            this.setState({ data: new MapEventData.WithParent(newData, null) });
        }
    }

    handleProtoContextMenuClick = (menuItem, e) => {
        console.log('handleProtoContextMenuClick', menuItem, e.props);
        switch (menuItem) {
            case 'Copy': {
                let clipboard = window.require('electron').remote.clipboard;
                let txt = JSON.stringify(e.props.value);
                clipboard.writeText(txt);
                break;
            }
            case 'Paste': {
                if (e.props.dispatchPath) {
                    let clipboard = window.require('electron').remote.clipboard;
                    this.dispatch({ type: 'SET', path: e.props.dispatchPath, value: JSON.parse(clipboard.readText()) });
                }
                break;
            }
            case 'Clear': {
                if (e.props.dispatchPath) {
                    this.dispatch({ type: 'DELETE', path: e.props.dispatchPath });
                }
                break;
            }
            default: {
                console.error('Unknown menu item', menuItem);
                break;
            }
        }
    }

    onChangeFile = e => {
        console.log(e.target.files);
        this.setState({ files: e.target.files });
    }

    load = () => {
        this.setState({ loading: true });
    }

    cancelLoad = () => {
        this.setState({ loading: false });
    }

    upload = () => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const newData = MapEventData.fromJson(JSON.parse(reader.result));
                this.setState({ loading: false, data: new MapEventData.WithParent(newData, null) });
            } catch (error) {
                this.setState({ loading: false, error: error.message, stack: error.stack });
            }

        };
        reader.readAsText(this.state.files[0]);
    }

    startDownload = () => {
        const text = JSON.stringify(this.state.data.selfValue.toJson(), null, 4);
        const href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
        this.setState({ href, downloading: true });
    }

    download = () => {
        const text = JSON.stringify(this.state.data.selfValue.toJson(), null, 4);
        var element = document.createElement('a');
        element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', 'MapEventData.json');

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

        this.setState({ downloading: false });
    }

    render() {
        const events = [];
        for (let e of this.state.data.selfValue.mapEvents) {
            events.push({ name: e.key });
        }
        const dataIndex = this.state.data.selfValue.mapEvents.findIndex(e => e.key === this.state.selected);
        const selectedData = dataIndex != -1 && new MapEvent.WithParent(this.state.data.selfValue.mapEvents[dataIndex], null);
        const selectedDispathPath = dataIndex != -1 && ['mapEvents', dataIndex];
        console.log(dataIndex, selectedData, selectedDispathPath, this.state.data, events);
        return (<div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Modal show={!!this.state.error} size="lg" centered onHide={() => this.setState({ error: null })}>
                <Modal.Header>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.error}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => this.setState({ error: null })}>OK</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={this.state.downloading} size="lg" centered onHide={() => this.setState({ downloading: false })}>
                <Modal.Header>
                    <Modal.Title>Download</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <a href={this.state.href} download="MapEventData.json">MapEventData.json</a>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={this.download}>Download</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={this.state.loading} size="lg" centered onHide={this.cancelLoad}>
                <Modal.Header>
                    <Modal.Title>Load file</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <input
                        onChange={this.onChangeFile}
                        type="file"
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={this.upload} disabled={this.state.files.length == 0}>Load</Button>
                </Modal.Footer>
            </Modal>
            <div>
                <Button onClick={this.load}>Load</Button>
                <Button onClick={this.startDownload}>Download</Button>
            </div>
            <h1>Map Event Editor</h1>
            {this.state.path &&
                <h2>File Path: {this.state.path}</h2>
            }
            <div style={{ flexGrow: 1, position: 'relative' }}>
                <SplitPane split="vertical" defaultSize={200} style={{ borderTop: 'solid 1px' }}>
                    <div style={{ padding: '12px' }}>
                        <ReactTable
                            className="-striped -highlight"
                            columns={this.eventListColumns}
                            pageSize={events.length}
                            showPagination={false}
                            getTdProps={this.getTdProps}
                            data={events}
                        />

                    </div>
                    <div style={{ position: 'relative', height: '100%' }}>
                        <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto', padding: '12px' }}>
                            {
                                selectedData &&
                                <table className="form-group table table-bordered">
                                    {false && <thead><tr><th>Field</th><th>Value</th></tr></thead>}
                                    <tbody>
                                        <ProtoEditor dispatch={this.dispatch} dispatchPath={selectedDispathPath} data={selectedData} />
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </SplitPane>
            </div>
            <FormContextMenu
                onClick={(i, e) => this.handleProtoContextMenuClick(i, e)}
            />
        </div>);
    }
}
